export const selfTaperRequestQueryKey = "selfTaperRequestQueryKey";
